import Furniture from './Furniture';
import { SPEED } from './Ant';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class AntHill extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.target = null;
    this.searchArea = new Phaser.Rectangle(
      this.x + this.data.area.x,
      this.y + this.data.area.y,
      this.data.area.w,
      this.data.area.h
    );

    this.spawnTime = 0.5;
    this.ants = [];
    this.antsPool = [];

    //
    this.addButton();

    //
    this.addMagnifierIcon();
  }

  createAsset() {
    this.asset = this.game.make.image(0, 0, this.data.key, 'anthill');
    this.asset.anchor.set(0.5, 1);
    this.addChildAt(this.asset, 0);
  }

  addButton() {
    this.asset.inputEnabled = true;
    this.asset.events.onInputDown.add(this.handleInputDown, this);
    this.asset.input.pixelPerfectClick = true;
    this.asset.input.pixelPerfectOver = true;
    this.asset.input.useHandCursor = true;
  }

  handleInputDown() {
    if (this.magnifierIcon.active) {
      this.magnifierIcon.hide();
    } else {
      this.magnifierIcon.show();
    }
  }

  //
  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.asset.tint = this.tintColor;
  }

  //
  lookForTarget() {
    const items = this.location.items;
    let target = null;
    let minDist = 1000;
    let dist = 0;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const pos = item.getPosForAnts();
      if (item.isTargetForAnt() && Phaser.Rectangle.contains(this.searchArea, pos.x, pos.y)) {
        const dx = this.x - pos.x;
        const dy = this.y - pos.y;
        dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < minDist) {
          minDist = dist;
          target = item;
        }
      }
    }
    return { target: target, distance: dist };
  }

  checkTarget() {
    // if no target try to find something and update ants target
    const result = this.lookForTarget();
    this.target = result.target;
    if (this.target) {
      this.distance = result.distance;
      this.requiredAnts = Math.max(1, Math.round((this.distance * 2) / SPEED));
      const pos = this.target.getPosForAnts();

      for (let i = 0; i < this.ants.length; i++) {
        this.ants[i].setTarget(pos.x, pos.y - 10, this.target);
      }
    }

    // if nothing found return ants to hill
    if (!this.target) {
      this.requiredAnts = 0;
      for (let i = 0; i < this.ants.length; i++) {
        this.ants[i].returnHome();
      }
    }
  }

  spawnAnt() {
    const x = this.x - 37;
    const y = this.y - 26;

    let ant;
    if (this.antsPool.length > 0) {
      ant = this.antsPool.shift();
    } else {
      ant = this.location.addFurniture({ id: 'ant', x: x, y: y });
    }
    ant.init(x, y);
    ant.setTarget(this.target.x, this.target.y - 10, this.target);
    ant.anthill = this;
    this.ants.push(ant);
  }

  removeAnt(ant) {
    const ind = this.ants.indexOf(ant);
    if (ind > -1) {
      this.ants.splice(ind, 1);
      ant.removeAnt();
      this.antsPool.push(ant);
    }
  }

  step(dt) {
    super.step(dt);

    // if has targer check if it still exist
    this.checkTarget();

    // spawn ants
    if (this.target && this.ants.length < this.requiredAnts) {
      this.spawnTime -= dt;
      if (this.spawnTime <= 0) {
        this.spawnTime = 1;
        this.spawnAnt();
      }
    }

    // magifier
    // if (this.target && !this.magnifierIcon.active) {
    //   this.magnifierIcon.show();
    // } else if (!this.target && this.magnifierIcon.active) {
    //   this.magnifierIcon.hide();
    // }
  }

  onCloseMacroView() {}
}
